import React from "react"
import PartialPaymentCard from "./cards";

const PartialPayment = () => {
    return <PartialPaymentCard />
}
export default PartialPayment;